import { createSlice } from '@reduxjs/toolkit';

import client from '../prismic';

// Slice
const dataSlice = createSlice({
  name: 'data',
  initialState: {
    loading: true,
    error: null,
    data: null,
  },
  reducers: {
    setLoadingAction: (state, action) => {
      state.loading = action.payload;
    },
    setErrorAction: (state, action) => {
      state.error = action.payload;
    },
    setDataAction: (state, action) => {
      state.data = action.payload;
    },
  },
});

const { setDataAction, setErrorAction, setLoadingAction } = dataSlice.actions;

// Thunk
export const fetchPages = () => (dispatch, getState) => {
  if (getState().data.data) return;

  client
    .getAllByType('post', {
      fetchLinks: ['category.name'],
    })
    .then((data) => dispatch(setDataAction(data)))
    .catch((err) => dispatch(setErrorAction(err)))
    .finally(() => dispatch(setLoadingAction(false)));
};

// Exports
export default dataSlice.reducer;
export { setDataAction, setErrorAction, setLoadingAction };
